<template>
    <div>
        <div class="alert alert-success" role="alert" v-if="!!successMessage">
            {{successMessage}}
        </div>


        <form id="contact_form" method="POST" action="" aria-label="Contact Form">
            <input type="hidden" :value="csrf" name="_token">
            <div class="form-group row">
                <div class="col-md-6">
                    <label for="name">First Name *</label>
                    <input type="text" id="name"
                           name="name"
                           v-model="name"
                           :class="invalidClass(errors.name)"
                           placeholder="Write Here" >

                    <span class="invalid-feedback" role="alert" v-if="errors.name">
                        <strong>Name field is required</strong>
                    </span>

                </div>
                <div class="col-md-6">
                    <label for="last">Last Name *</label>
                    <input type="text" id="last"
                           name="last"
                           v-model="last_name"
                           :class="invalidClass(errors.last_name)"
                           placeholder="Write Here" >

                    <span class="invalid-feedback" role="alert" v-if="errors.last_name">
                        <strong>Last Name field is required</strong>
                    </span>

                </div>
                <div class="col-md-12 mt-3">
                    <label for="email">E-mail *</label>
                    <input type="email" name="email"
                           :class="invalidClass((errors.email || errors.invalid_email))"
                           v-model="email">

                    <span class="invalid-feedback" role="alert" v-if="errors.email">
                        <strong>Email field is required</strong>
                    </span>
                    <span class="invalid-feedback" role="alert" v-if="errors.invalid_email">
                        <strong>Invalid Email</strong>
                    </span>

                </div>
                <div class="col-md-12 mt-3">
                    <label for="comment">Comment *</label>
                    <textarea id="comment" name="comment"
                              v-model="comment"
                              :class="invalidClass(errors.comment)">
                    </textarea>

                    <span class="invalid-feedback" role="alert" v-if="errors.comment">
                        <strong>Comment field is required</strong>
                    </span>

                </div>
                <div class="col-md-6 text-left mt-4">
                    <p class="annotation">Fields marked with * are required</p>
                </div>
                <div class="col-md-6 text-right mt-4">
                    <button type="submit" class="btn btn-success" @click.prevent="submit">Submit</button>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    export default {
        props:{
            route:{
                required:true,
            },
            successMessage:{
                default:null,
            }
        },
        data(){
            return {
                name:'',
                last_name:'',
                email:'',
                comment:'',
                validating:false
            }
        },
        computed:{
            errors(){
                return {
                    name: this.validating && this.name.trim()==="",
                    last_name: this.validating && this.last_name.trim()==="",
                    email: this.validating && this.email.trim()==="",
                    invalid_email: this.email.trim()!=="" && this.validating && !this.validateEmail(this.email),
                    comment: this.validating && this.comment.trim()==="",
                };
            },
            csrf(){
                return window.App.csrf_token;
            }
        },
        methods:{
            submit(){
                if(this.validate()){
                    $('#contact_form').submit();
                }
            },
            validate(){
                let hasError = false;
                this.validating = true;
                for (let x in this.errors){
                    if(this.errors[x]){
                        hasError = true;
                    }
                }
                return !hasError;
            },
            validateEmail(mail) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return true;
                }
                return false
            },
            invalidClass(invalid){
                if(invalid){
                    return "form-control is-invalid"
                }
                return 'form-control'
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/contact_us/ContactUsFrom.vue